import React, {useState} from 'react';
import { ForgretPassword } from '../../Data';
import {toast} from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ForgetPassAR = () => {
    const [email, setEmail] = useState("")
    const navigate = useNavigate();

    const handleSubmit = () => {
        ForgretPassword(email).then((response) => {
            if (response.ok) {
              setEmail("");
              toast.success("يرجى التحقق من البريد الإلكتروني الخاص بك");
              navigate("/AR/Reset-Password")
            } else {
              toast.error("هذا البريد الإلكتروني غير موجود ، يرجى التسجيل");
            }
          });
    }
    return (
        <>
            <div className="container mt-5">
                <div className="breadcrumb-area mb-5 ">
                    <div className="container ">
                        <div className="row ">
                            <div className="col ">
                                <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                                    <div className="breadcrumbArabic HomeShop">
                                        <ul>
                                            <li className="active">نسيت كلمة المرور</li>
                                            <li><a style={{ direction: 'rtl' }} href="/"><i className="fa fa-home"></i>
                                                المنزل</a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8">
                        <div className="authenticationCard">
                            <div className="row topBar">
                                <div className="col-12 text-center">
                                    {/* <button className='active'>Forget Password</button> */}
                                </div>
                            </div>
                            <div className="row mb-35">
                                <div className="col-12 col-md-2"><label>البريد الالكتروني:</label></div>
                                <div className="col-12 col-md-10">
                                    <input className="form-control" placeholder="Type Here" required onChange={(e) => setEmail(e.target.value)}></input>
                                </div>
                            </div>
                            <div className="row mb-3 submit">
                                <div className="col-12 text-center">
                                    <button className="Resend-button mt-0" onClick={(e) => handleSubmit(e)}>Send Code</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgetPassAR